export default {
	min: '0',
	mid: '1',
	max: '2',
	small: '3'
}